var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EduComponent } from "../utils/eduComponent";
var StudentLogin = /** @class */ (function (_super) {
    __extends(StudentLogin, _super);
    function StudentLogin(userService, router) {
        var _this = _super.call(this) || this;
        _this.username = "";
        _this.secretQuestion = "Secret Question N/A";
        _this.isLoginValid = "Not evaluated";
        _this.isLoginInitiated = false;
        _this.isLoginValidationInitiated = false;
        _this.loginStep = 1;
        _this.userService = userService;
        _this.router = router;
        return _this;
    }
    // INFO: First step of user (student) login, the username is requested
    StudentLogin.prototype.initiateLogin = function (username) {
        var _this = this;
        this.isLoginInitiated = true;
        this.username = username;
        this.clearSubs();
        this.addSub(this.userService
            .postStudentUsername(username)
            .subscribe(function (response) {
            if (response && response.secret_question != null) {
                _this.secretQuestion = response.secret_question;
                _this.loginStep = 2;
            }
            else {
                _this.secretQuestion = null;
                _this.loginStep = 1;
            }
        }));
    };
    // INFO: Last step of user (student) login, the secret answer is requested
    StudentLogin.prototype.validateLogin = function (secretAnswer) {
        var _this = this;
        this.isLoginValidationInitiated = true;
        this.clearSubs();
        this.addSub(this.userService
            .postSecretAnswer(this.username, this.secretQuestion, secretAnswer, this.getCurrentStudentPath())
            .subscribe(function (response) {
            if (response && response.authenticated) {
                _this.isLoginValid = "True";
                // INFO: Extra check, the response should always have a "next_url" attribute.
                if (response.next_url) {
                    _this.router
                        .navigate([response.next_url])
                        .then(function () {
                        window.location.reload();
                    });
                }
                else {
                    window.location.reload();
                }
            }
            else {
                _this.isLoginValid = "False";
            }
        }));
    };
    StudentLogin.prototype.shouldDisplayUsernameInput = function () {
        return this.loginStep === 1;
    };
    StudentLogin.prototype.shouldDisplayQuestionInput = function () {
        return this.loginStep === 2;
    };
    StudentLogin.prototype.generateLabelFromSecretQuestion = function () {
        if (this.secretQuestion) {
            return this.secretQuestion
                .slice(0, -1)
                .split(" ")
                .splice(-2)
                .join(" ");
        }
        return "Secret Answer";
    };
    StudentLogin.prototype.getSecretQuestion = function () {
        if (this.secretQuestion) {
            return this.secretQuestion;
        }
        return null;
    };
    StudentLogin.prototype.restoreInitialSecretQuestionValue = function () {
        this.secretQuestion = "Secret Question N/A";
    };
    StudentLogin.prototype.getLoginValidity = function () {
        return this.isLoginValid;
    };
    StudentLogin.prototype.restoreInitialLoginEvaluationValue = function () {
        this.isLoginValid = "Not evaluated";
    };
    // INFO: Get the current path for a student account and set his right homepage if he logs from "/".
    StudentLogin.prototype.getCurrentStudentPath = function () {
        if (window.location.pathname !== "/") {
            return window.location.pathname;
        }
        return "/student/";
    };
    return StudentLogin;
}(EduComponent));
export { StudentLogin };
